import { render, staticRenderFns } from "./UnlockResignModal.vue?vue&type=template&id=4551e0da&scoped=true"
import script from "./UnlockResignModal.vue?vue&type=script&lang=js"
export * from "./UnlockResignModal.vue?vue&type=script&lang=js"
import style0 from "./UnlockResignModal.vue?vue&type=style&index=0&id=4551e0da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551e0da",
  null
  
)

export default component.exports